<template>
  <div
    class="aside"
    v-bind:style="{ height: asideHeight + 'px' }"
    v-if="oidcUser"
  >
    <div class="myaccount"  v-bind:style="{ height: asideHeight + 'px' }">
      <div class="mc-header">
        <h4>My Account</h4>
        <span class="ma-close-btn" @click="toggleAsidebar">
          <b-icon-x></b-icon-x>
        </span>
      </div>
      <div class="ma-body">
        <div class="ma-profile-pic">
          <img
            src="../assets/images/sandy.jpg"
            class="user-image"
            alt="User Image"
            style="width: 100%"
          />
        </div>
        <div class="ma-profile">
          <h5>{{ oidcUser.unique_name }}</h5>
          <p>{{ oidcUser.email }}</p>
        </div>
      </div>
      <div class="p-3">
        <!-- <div class="theme-app pt-3">
          <h5>Theme Setting</h5>

          <themeswitcher />
        </div> -->
        <div class="list-group list-group-flush ma-liks">
          <a
            href="#"
            v-if="empData.length != 0"
            class="list-group-item list-group-item-action"
          >
            <span class="ma-linksicon">
              <b-icon icon="person-square"></b-icon>
            </span>
            <router-link class="list-group-item-action" to="/profile"
              >Profile</router-link
            >
          </a>
          <a
            href="#"
            @click="changePwd"
            class="list-group-item list-group-item-action change_pswd_btn"
          >
            <span class="ma-linksicon">
              <b-icon icon="app-indicator"></b-icon>
            </span>
            Change Password
          </a>
          <a
            href="#"
            @click="logout"
            class="list-group-item list-group-item-action logout_action_btn"
          >
            <span class="ma-linksicon">
              <b-icon icon="lock-fill"></b-icon> </span>
              Logout
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import themeswitcher from "./ThemeSwitcher";
import { mapGetters } from "vuex";
// import { MESSAGES } from "@/utils/constants";
// import { notify, notifyError } from "@/utils/notification-helper";
export default {
  components: {
    // themeswitcher,
  },
  name: "asside",
  data: function () {
    return {
      asideHeight: 400,
    };
  },
  methods: {
    toggleAsidebar: function () {
      this.$root.$emit("flyoutAsidebar");
      this.showAsidebar = !this.showAsidebar;
    },
    getDataOnload() {
      
    },
    logout() {
      this.$store.dispatch("oidcStore/signOutOidc");
      localStorage.removeItem("isActive");
      // this.$store.dispatch("oidcStore/removeOidcUser");
    },
    changePwd() {
      this.$router.push({ name:'change-password' });
    },
    handleResize: function () {
      this.asideHeight = window.innerHeight;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getDataOnload();
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
    empData() {
      return this.$store.state.EmpData;
    },
  },
};
</script>
